export function extractFormData(submitButton) {
  var form = submitButton.closest('form');
  if (!form) {
    console.error('The submit button does not belong to any form.');
    return null;
  }
  var variantIdInput = form.querySelector('input[name="id"]');
  if (!variantIdInput || !variantIdInput.value) {
    console.error('The form does not contain a valid "id" input.');
    return null;
  }
  var quantity = 1;
  var quantityInput = form.querySelector('input[name="quantity"]');
  if (quantityInput && quantityInput.value) {
    quantity = parseInt(quantityInput.value, 10);
  }
  var sellingPlanId = '';
  var sellingPlan = form.querySelector('[name="selling_plan"]');
  if (sellingPlan && sellingPlan.value) {
    sellingPlanId = sellingPlan.value;
  }
  var recipientName = form.querySelector('input[name="properties[Recipient Name]"]');
  var recipientEmail = form.querySelector('input[name="properties[Recipient Email]"]');
  var personalNote = form.querySelector('input[name="properties[Personal Note]"]');
  var senderName = form.querySelector('input[name="properties[Sender Name]"]');
  var senderEmail = form.querySelector('input[name="properties[Sender Email]"]');
  var formData = {
    items: [{
      id: parseInt(variantIdInput.value, 10),
      quantity: quantity,
      selling_plan: parseInt(sellingPlanId),
      properties: {
        'Recipient Name': recipientName === null || recipientName === void 0 ? void 0 : recipientName.value,
        'Recipient Email': recipientEmail === null || recipientEmail === void 0 ? void 0 : recipientEmail.value,
        'Sender Name': senderName === null || senderName === void 0 ? void 0 : senderName.value,
        'Sender Email': senderEmail === null || senderEmail === void 0 ? void 0 : senderEmail.value,
        'Personal Note': personalNote === null || personalNote === void 0 ? void 0 : personalNote.value
      }
    }],
    sections: 'ajax-side-cart,ajax-cart-icon'
  };
  return formData;
}
export function parseHTMLSection(section) {
  var parser = new DOMParser();
  var doc = parser.parseFromString(section, 'text/html');
  return doc.body.firstChild;
}